import React from 'react'
import { FaCloudMoon ,IoSunnyOutline} from "../icons";

import { useStateContext } from '../../context/ContextProvider'
import SmallButton from './SmallButton';

const MoodToggle = () => {

    const { setMode, currentMode } = useStateContext();
  
    const handleThemeChange = () => {

      if (currentMode === 'Dark') {
        setMode('Light');
      } else if (currentMode === 'Light') {
        setMode('Dark');
      }

    }
  
  return (
    <SmallButton onClick={handleThemeChange} >{currentMode === 'Light' ? <IoSunnyOutline className='text-light-blue text-2xl m-2'/> : <FaCloudMoon className='text-dark-text text-2xl m-2'/>}</SmallButton>
   
  )
}

export default MoodToggle